/**
 * Card Footer Component
 */
import { twMerge } from 'tailwind-merge';

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export function CardFooter({ children, className }: CardFooterProps) {
  return (
    <div
      className={twMerge(
        'flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 dark:border-gray-800',
        className,
      )}
    >
      {children}
    </div>
  );
}
